import { mapStateToControlProps, rankWith } from '@jsonforms/core';
import { html } from '@microsoft/fast-element';
import { isOneOfDate } from '../testers/isDate';
import { DATE_CONTROL_RANK } from './RenderersRanks';
export const DateControlRendererTemplate = (prefix = 'zero') => html `
  <template>
    <control-wrapper
      :control=${(x) => x.control}
      :touched=${(x) => x.touched}
      ?submitted=${(x) => x.submitted}
    >
      <${prefix}-text-field
        :value=${(x) => x.control.data === undefined || x.control.data === null
    ? ''
    : new Intl.DateTimeFormat('fr-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'UTC',
    }).format(x.control.data)}
        id=${(x) => x.control.path}
        type="date"
        data-test-id=${(x) => x.control.path}
        ?required=${(x) => x.control.required}
        ?disabled=${(x) => !x.control.enabled}
        @blur=${(x, c) => {
    const dateValue = c.event.target.control.valueAsNumber;
    x.onBlur();
    x.control.handleChange(x.control.path, !isNaN(dateValue) ? dateValue : undefined);
}}"
        style="width: 100%"
      ></${prefix}-text-field>
    </control-wrapper>
  </template>
`;
export const DateControlRendererEntry = {
    renderer: html `
    ${(x) => DateControlRendererTemplate(x.jsonforms.prefix)}
  `,
    tester: rankWith(DATE_CONTROL_RANK, isOneOfDate),
    mapper: mapStateToControlProps, // TODO: change mapper to handle dates instead of doing it in the template
};
